<template>
  <div class="screen-share-wrap">
    <div class="screen-share__video" ref="shareVideo"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { eventBus } from '@/lib/events';

export default {
  name: 'VideoContainer',
  props: {
    participant: {},
    localTrack: {},
  },
  watch: {
    localTrack: {
      immediate: true,
      handler() {
        this.attachTracks();
      },
    },
    participant: {
      immediate: true,
      handler() {
        this.attachTracks();
      },
    },
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
  },
  methods: {
    getSharedTracks() {
      if (this.participant?.identity === this.roomInfo.identity) {
        return [this.localTrack];
      }

      if (!this.participant?.tracks) return [];
      const tracksArr = [...this.participant.tracks.values()];
      const sharedTracks = tracksArr.filter(({ trackName }) => {
        let name = trackName || '';
        return name.endsWith('_sv') || name.endsWith('_sa');
      });
      return sharedTracks.map((i) => i?.track || i);
    },

    async attachTracks() {
      await this.$nextTick();

      const tracks = this.getSharedTracks();
      if (!tracks.length) {
        this.removePreviousElements();
        return;
      }

      const shareContainer = this.$refs?.shareVideo;
      if (!shareContainer) return;

      // remove previous video element
      this.removePreviousElements();

      tracks.forEach((track) => {
        if (track?.attach) {
          const trackElement = track.attach();
          shareContainer.appendChild(trackElement);
        }
      });
    },

    removePreviousElements() {
      const shareContainer = this.$refs?.shareVideo;
      if (!shareContainer) return;

      let elements = shareContainer.querySelectorAll('video, audio');
      elements.forEach((el) => {
        el.remove();
      });
    },
  },

  mounted() {
    eventBus.on('shareTracksUpdated', () => {
      this.attachTracks();
    });
  },
};
</script>

<style lang="less">
.screen-share-wrap {
  position: relative;
}
.screen-share__video {
  background: rgba(0, 0, 0, 0.7);
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  max-width: 100%;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 2;
  }

  &:has(audio) {
    &:before {
      content: '\e3a1';
      font-family: @icons-font;
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      font-size: 140px;
      color: var(--v-primary-base);
      z-index: 1;
    }
  }
}
</style>
